import React, { useState } from 'react';
import { Tooltip } from '@firesoon/antd';
import { Exitfullscreen, Fullscreen } from '@firesoon/icons-react';
import RadioGroup from './RadioGroup';
import Download from '../Download';
import './index.less';

const Extra = ({
  hasRadio,
  extraRadios,
  type,
  isFull,
  hasFull,
  toggle,
  onChangeRadio,
  defaultType,
  customExtra,
  hideDownload,
  download,
  fullLogValue,
}) => {
  const [loading, setLoading] = useState(false);
  const clickDownload = () => {
    setLoading(true);
    download();
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  return (
    <div className="fs-full-screen-extra">
      {/* 自定义内容 */}
      {customExtra}

      {/* 快捷的分布、趋势切换 */}
      {/* todo: 多封装几个快捷切换 */}
      {hasRadio && (
        <RadioGroup
          extraRadios={extraRadios}
          type={type}
          isFull={isFull}
          defaultType={defaultType}
          onChange={onChangeRadio}
        />
      )}

      {isFull && !hideDownload && <Download onClick={clickDownload} loading={loading} disabled={loading} />}

      {hasFull && (
        <Tooltip
          title={isFull ? '退出全屏' : '全屏'}
          placement={isFull ? 'bottom' : 'top'}
          getPopupContainer={() => document.body}
          key={`tips-${isFull}`} // 全屏状态改变时，重新渲染，控制文案展示隐藏状态
        >
          <span onClick={() => toggle()} className="fs-full-screen-icon auto-track" data-log-value={fullLogValue}>
            {isFull ? <Exitfullscreen /> : <Fullscreen />}
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default Extra;
